import { AuthService } from './../../../core/services/auth-service/auth.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CPassoword } from './../../../core/models/login';
import { changedPassword, serverError } from './../../../core/models/messages';
import { MustMatch } from './../../../core/models/must-match-validator';
import { patternPassword } from './../../../core/models/pattern';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '@env/environment';
import { ReCaptchaService } from '@shared/services/reCaptcha.service';
export const passwordMatchValidator: ValidatorFn = (
  formGroup: AbstractControl
): ValidationErrors | null => {
  if (
    formGroup.get('newPassword')!.value ===
    formGroup.get('confirmPassword')!.value
  )
    return null;
  else return { passwordMismatch: true };
};

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent {
  env = environment
  /* formGroup */
  generateResePasswordForm: FormGroup = this.resetPasswordForm(
    new CPassoword()
  );
  /* string */
  showPassword: string = 'password';
  showConfirmPassword: string = 'password';
  userEmail!: string;
  /* boolean */
  loadSpinner: boolean = false;
  token?:string; 
  termFlag: number = 0;
  term: any;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private reCaptchaService: ReCaptchaService,
  ) {}
  ngOnInit() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.token = params.params['token'];
        if(this.token) {
          this.retrieveTermFlag(this.token);
        }
      }
    })
  }
  touchedPass() {
    this.generateResePasswordForm.markAllAsTouched();
    this.generateResePasswordForm.markAsDirty();
  }

  /* create resetPassword form */
  resetPasswordForm(data: any) {
    return this.formBuilder.group(
      {
        newPassword: [
          data?.newPassword,
          [Validators.required, Validators.pattern(patternPassword)],
        ],
        confirmPassword: [
          data?.confirmPassword,
          [Validators.required, Validators.pattern(patternPassword)],
        ],
        terme: [data.terme, [this.termFlag? Validators.required : Validators.nullValidator]],
        newsLetter: [data.newsLetter? data.newsLetter : false],
        telAssistance: [data.telAssistance? data.telAssistance : false],
      },
      { validator: MustMatch('newPassword', 'confirmPassword') }
    );
  }

  /* send new password   */
  resetPassword() {   
    if (this.generateResePasswordForm.valid) {
      this.spinner.show();
      this.loadSpinner = true;
      this.reCaptchaService.executeAction('resetPassword').then(token => {
        let payload: any = {
          t_uuid: this.token,
          newPassword: this.generateResePasswordForm.get('newPassword')?.value,
          recaptchaToken: token
        };

      if (this.termFlag === 0) {
        payload.terme = this.generateResePasswordForm.get('terme')?.value;
        payload.telAssistance = this.generateResePasswordForm.get('telAssistance')?.value;
        payload.newsLetter = this.generateResePasswordForm.get('newsLetter')?.value;
        payload.isNew = false;
      }
      this.authService
        .restPassword(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.loadSpinner = false;
            if (res.status == 200) {
              this.spinner.hide();
              this.toastrService.success(changedPassword);
              this.router.navigate(['/auth/login']);
            }
          },
          error: () => {
            this.spinner.hide();
            this.loadSpinner = false;
            this.toastrService.error(serverError);
          },
        });
    }
      ).catch(() => {
        this.spinner.hide();
        this.loadSpinner = false;
        this.toastrService.error('ReCaptcha validation failed. Please try again.');
      });
    }
  }

  retrieveTermFlag(tuuid: string) {
    this.spinner.show();
    return this.authService.retrieveTermFlag(tuuid).subscribe({
      next: (res) => {
        if (res.status == 200) {
          this.spinner.hide();
          this.termFlag = res.data?.terme
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        this.toastrService.error(serverError);
         this.termFlag = 0;    
      },
    });;
  }

  terms(){
    this.term=this.generateResePasswordForm.get("terme")?.value;
  }

  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
